// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--2-hg1";
export var copyright = "footer-module--copyright--3yIxz";